/**
 * Descarta las claves con valor falsy antes de mezclar los parámetros en el request,
 * igual que hacía el client legacy (`destinatary.client.api.ts`). Sin esto un
 * `undefined` / `''` / `0` explícito viaja igual y pisa el default que el service pone
 * después en el spread — que es como un `countryCode: undefined` terminaba anulando
 * `EXCLUDE_STABLECOINS_REGEX`.
 *
 * @param params - parámetros de búsqueda; `undefined` devuelve un objeto vacío
 * @returns copia con solo las claves cuyo valor es truthy
 */
export function filterTruthyParams<T extends object>(params?: T): Partial<T> {
  if (!params) return {};

  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => Boolean(value))
  ) as Partial<T>;
}
